import MemoriqueIconGold from "../../assets/icons/MemoriqueIconGold";
import GlobalMapIllustration from "../../components/GlobalMapIllustration";
import guildLogo from "../../assets/images/guild-mortgage-logo.png";

interface AccountLayoutProps {
  children?: React.ReactNode;
  showGuildBranding?: boolean;
}

const SignUpContainerLayout = ({
  children,
  showGuildBranding = false,
}: AccountLayoutProps) => {

  return (
    <div className="account-pages" style={{ background: "#ffffff", width: "100%", height: "100vh", overflow: "hidden", position: "relative" }}>
      <div className={`top-logo-container${showGuildBranding ? " guild-signup-logos" : ""}`}>
        {showGuildBranding && (
          <>
            <img src={guildLogo} alt="Guild Mortgage" />
            <span className="guild-signup-logo-divider" aria-hidden="true" />
          </>
        )}
        <MemoriqueIconGold width={showGuildBranding ? "150px" : "200px"} />
      </div>
      
      <div className="main_wrapper_login">
          <div className="left_view_wrapper">
            <div className="marketing-content">
              <h1 className="marketing-title">
                Generate reviews, referrals, leads, and data through gifting
              </h1>
              <p className="marketing-description">
                Transform every gift into valuable business insights.
              </p>
              <div className="illustration-wrapper">
                <GlobalMapIllustration />
              </div>
            </div>
          </div>

          <div className="right_view_wrapper">
            <div className="login-form-container signup-form-container">
              <div className="login-header">
                <h2 className="welcome-title">Let's Set Up Your Gifting Account</h2>
                <p className="welcome-subtitle">Start your journey with Memorique</p>
              </div>

              <div className="gradient-form-card signup-form-card">
                {children}
              </div>
            </div>
          </div>
        </div>
    </div >
  );
};

export default SignUpContainerLayout;
